import React, {Component} from 'react';
import { attempEditSalaryAdjust, attempDelSalaryAdjust } from 'actions/UserActions';

const NormalBtnGrp = ({activeEidt, activeDel}) => (
  <td>
    <button className="btn btn-default" onClick={activeEidt}>
      修改
    </button>
    {" "}
    <button className="btn btn-danger" onClick={activeDel}>
      删除
    </button>
  </td>
)

const EditBtnGrp = ({saveEdit, dismiss}) => (
  <td>
    <button className="btn btn-primary" onClick={saveEdit}>
      儲存
    </button>
    {" "}
    <button className="btn btn-default" onClick={dismiss}>
      取消
    </button>
  </td>
)

const DelBtnGrp = ({dismiss, handleDel}) => (
  <td>
    <button className="btn btn-danger" onClick={handleDel}>
      確認
    </button>
    {" "}
    <button className="btn btn-default" onClick={dismiss}>
      取消
    </button>
  </td>
)

class SalaryAdjustRow extends Component {
  state = {
    edit: false,
    del: false,
    editAmount: 0,
    editTypeID: 0,
    editNote: "",
  }

  activeEidt = () => {
    this.setState({
      edit: true,
      editAmount: this.props.amount,
      editTypeID: this.props.typeID,
      editNote: this.props.note,
    })
  }

  activeDel = () => {
    this.setState({
      del: true
    })
  }

  dismiss = () => {
    this.setState({
      del: false,
      edit: false
    })
  }

  handleChange = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState({
      [name]: val
    })
  }

  handleSaveEdit = () => {
    let oldVal = {
      id: this.props.id,
      amount: this.props.amount,
      typeID: this.props.typeID,
      note: this.props.note,
    }

    let newVal = {
      id: this.props.id,
      amount: this.state.editAmount,
      typeID: this.state.editTypeID,
      note: this.state.editNote,
    }

    this.props.dispatch(attempEditSalaryAdjust(oldVal, newVal));
    this.dismiss();
  }

  handleSelect = (e) => {
    this.setState({
      editTypeID: parseInt(e.target.value, 10)
    })
  }

  handleDel = () => {
    this.props.dispatch(attempDelSalaryAdjust(this.props.id));
    this.dismiss();
  }

  render() {
    let {amount, typeID, note, adjustmentTypeList} = this.props;
    let {edit, del, editAmount, editTypeID, editNote} = this.state;

    return (
      <tr>
        <td className="salary__modal__table__amount">
          {(edit?
              <input
                value={editAmount}
                className="form-control"
                name="editAmount"
                placeholder="金額"
                onChange={this.handleChange}/>
            :
              "$ " + amount)}
        </td>
        <td className="salary__modal__table__type">
          {(edit?
            <select
              className="form-control"
              value={editTypeID}
              onChange={this.handleSelect} >
              {adjustmentTypeList.map(adjustment=>
                <option value={adjustment.get('id')}>{adjustment.get('name')}</option>
              )}
            </select>
            :
              adjustmentTypeList.get(adjustmentTypeList.findIndex(type=>type.get('id') === typeID)).get('name'))}
        </td>

        <td className="salary__modal__table__notes">
          {(edit?
              <input 
                className="form-control"
                name="editNote"
                placeholder="備註"
                value={editNote}
                onChange={this.handleChange} />
            :
              note)}
        </td>

        {edit && <EditBtnGrp dismiss={this.dismiss} saveEdit={this.handleSaveEdit}/>}
        {del && <DelBtnGrp dismiss={this.dismiss} handleDel={this.handleDel} />}
        {(!edit && !del) &&
          <NormalBtnGrp activeEidt={this.activeEidt} activeDel={this.activeDel} />}
      </tr>
    )
  }
}

export default SalaryAdjustRow;



// WEBPACK FOOTER //
// ./src/components/Salary/SalaryAdjustRow.js